/*
 * ca-card-guard.js
 * ---------------------------------------------------------------------------
 * Third-party apps (Globo Pre-Order, quote widgets) inject their buttons into
 * product cards asynchronously, and they don't always land in the action row.
 * When they land loose inside .customCard they escape the card's layout and
 * overlap the grid — the "Pre order / Lead Time / Reserve yours now" spill.
 *
 * This observer moves any stray widget into the card's .pdpButtons row, which
 * is a normal flex container. Moving a node preserves its event listeners, so
 * the app keeps working exactly as before.
 *
 * Cheap by design: debounced, only scans cards that actually changed, and
 * marks handled nodes so it never re-processes them.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  var WIDGET_SELECTOR = [
    '[class*="globo-preorder"]',
    '[class*="Globo-preorder"]',
    '[id*="globo-preorder"]',
    '.gpo-wrapper',
    '.gpo-container',
    '.wfq-quote-collection-btn'
  ].join(',');

  var HANDLED = 'data-ca-placed';
  var scheduled = false;

  function isBadge(node) {
    var cls = (node.className || '').toString().toLowerCase();
    return cls.indexOf('badge') !== -1 || cls.indexOf('ribbon') !== -1 || cls.indexOf('label') !== -1;
  }

  function placeWidgets(root) {
    var cards = (root || document).querySelectorAll('.avsCard .customCard');

    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var row = card.querySelector('.pdpButtons');
      if (!row) continue;

      var widgets = card.querySelectorAll(WIDGET_SELECTOR);

      for (var j = 0; j < widgets.length; j++) {
        var w = widgets[j];

        if (w.hasAttribute(HANDLED)) continue;

        // Badges belong pinned on the image, not in the action row.
        if (isBadge(w)) {
          w.setAttribute(HANDLED, 'badge');
          continue;
        }

        // Already inside the action row (or nested in something that is).
        if (row.contains(w)) {
          w.setAttribute(HANDLED, 'inrow');
          continue;
        }

        // Skip nested widgets — only relocate the outermost one.
        if (w.parentElement && w.parentElement.closest(WIDGET_SELECTOR)) continue;

        try {
          row.appendChild(w);
          w.setAttribute(HANDLED, 'moved');
        } catch (e) {
          /* If the app is mid-render, the next tick will pick it up. */
        }
      }
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || window.setTimeout)(function () {
      scheduled = false;
      placeWidgets(document);
    }, 16);
  }

  function start() {
    placeWidgets(document);

    if (!('MutationObserver' in window)) return;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          schedule();
          return;
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Collection filtering swaps the grid out wholesale.
    document.addEventListener('shopify:section:load', schedule);
    window.addEventListener('pageshow', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
